export * from "/vercel/path0/node_modules/@iconify/react/dist/iconify.js"